module.exports = __webpack_public_path__ + "static/media/customer-bimbo.8cb370b2.png";